import { useQuery } from 'react-query';
import { checkoutService } from 'services';
import { ServerStateKeysEnum } from '../constants';
import getConfig from 'next/config';

export const usePayments = () => {
  const { publicRuntimeConfig } = getConfig();
  const storeRegion = publicRuntimeConfig.STORE_REGION;
  return useQuery(
    `${ServerStateKeysEnum.doctorCreditCards}`,
    () => {
      return checkoutService.getDoctorCreditCards();
    },
    {
      staleTime: storeRegion === 'EMEA' ? 0 : Infinity,
      refetchOnWindowFocus: 'always',
    }
  );
};
